import { motion } from "framer-motion";
import { fadeUp, viewportOnce, stagger } from "../../lib/motion";
import { trackEvent } from "../../lib/seo";
import { PRO_ECOSYSTEM } from "../../lib/pro";

const ProEcosystem = () => (
    <section
        id="pro-ecosystem"
        data-testid="pro-ecosystem-section"
        className="relative py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-pro-steel-light">
                    THE PROFESSIONAL ECOSYSTEM
                </p>
                <span className="h-px flex-1 bg-pro-steel/40" />
            </motion.div>

            <motion.h2
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                data-testid="pro-ecosystem-headline"
                className="mt-12 max-w-4xl font-display text-4xl font-semibold leading-[1.1] text-pro-platinum md:text-6xl"
            >
                {PRO_ECOSYSTEM.headline}
                <span className="text-accent">.</span>
            </motion.h2>
            <motion.p
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-6 max-w-3xl text-[16px] leading-relaxed text-pro-steel-light"
            >
                {PRO_ECOSYSTEM.copy}
            </motion.p>

            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-14 grid gap-px border border-pro-steel/30 bg-pro-steel/30 md:grid-cols-2 lg:grid-cols-5"
            >
                {PRO_ECOSYSTEM.benefits.map((b) => (
                    <motion.div
                        key={b.n}
                        variants={fadeUp}
                        data-testid={`pro-benefit-${b.n}`}
                        className="flex flex-col bg-pro-navy p-6"
                    >
                        <span className="font-mono text-[13px] tracking-[0.22em] text-accent">
                            {b.n}
                        </span>
                        <h3 className="mt-5 font-display text-lg font-semibold leading-snug text-pro-platinum">
                            {b.title}
                        </h3>
                        <p className="mt-3 flex-1 text-[15px] leading-relaxed text-pro-steel-light">
                            {b.copy}
                        </p>
                    </motion.div>
                ))}
            </motion.div>

            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-16 flex flex-col gap-6 border-t border-pro-steel/30 pt-10 md:flex-row md:items-center md:justify-between"
            >
                <p
                    data-testid="pro-participation-line"
                    className="max-w-xl font-display text-xl font-semibold leading-snug text-pro-platinum md:text-2xl"
                >
                    {PRO_ECOSYSTEM.participation}
                    <span className="text-accent">.</span>
                </p>
                <a
                    href="#pro-enquiry"
                    data-testid="pro-ecosystem-cta"
                    onClick={() =>
                        trackEvent("pro_pathway_click", "pro_ecosystem")
                    }
                    className="group inline-flex shrink-0 items-center gap-2 bg-accent px-7 py-4 text-[16px] font-semibold text-white transition-colors duration-300 hover:bg-[#ff7026]"
                >
                    Join the Professional Network
                </a>
            </motion.div>
        </div>
    </section>
);

export default ProEcosystem;
